import React from 'react'
import {
  List
} from './index'
import { ListFilter, FloatingFilter } from '../../../components'
import dummyData from '../../../database/resources.json'
// import { Featured } from './featured'

const MainContentMobile = ({embed, category, byId, resourceIds, resourceCategoryId}) => {
  const [filtered, setFiltered] = React.useState(false)
  const [data, setData] = React.useState(dummyData)

  React.useEffect(() => {
    if(filtered){
      setData(dummyData.slice(0, 3))
    }else{
      setData(dummyData)
    }
  }, [filtered])

  React.useEffect(() => {
    if(category){
      const categoryId = category.id
      if (categoryId) {
        // Search for post that match the category id
        setData(dummyData.filter((d => d.categories.includes(categoryId))))
      } else {
        setData(dummyData)
      }
    }else{
      setData(dummyData)
    }
  }, [category])

  React.useEffect(() => {
    if(byId && resourceIds){
      let result = []
      // filtered by region resources
      const filtered1 = dummyData.filter(d => resourceIds.includes(d.id))
      // filtered by resource category
      if(resourceCategoryId){
        result = filtered1.filter(d => d.categories.includes(resourceCategoryId))
      } else {
        result = filtered1
      }
      setData(result)
    }
  }, [byId, resourceIds, resourceCategoryId])

  return (
    <div className={`${embed ? '' : 'pt-5'}`}>
      {/* {
        !filtered &&
        <Featured embed={embed} data={data}/>
      } */}
      <div className="md:hidden">
        <ListFilter filtered={filtered} setFiltered={setFiltered}/>
      </div>
      <div className="hidden md:block">
        <div className="container mx-auto">
          <ListFilter filtered={filtered} setFiltered={setFiltered}/>
        </div>
      </div>
      <section className="container mx-auto">
        <List data={data}/>
      </section>
      <FloatingFilter onSubmit={() => setFiltered(true)}/>
    </div>
  )
}

export { MainContentMobile }
